import { render, staticRenderFns } from "./orderListAuth.vue?vue&type=template&id=78a1782b&"
import script from "./orderListAuth.vue?vue&type=script&lang=js&"
export * from "./orderListAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports